export const PenaltyChangeGoalKeeper = {
  name: "penalty-change-goal-keeper",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "changeGoalkeeper",
  showOn: [{ state: "primary", value: "penalty-change-goal-keeper", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  children: [
    {
      name: "penalty-change-goal-keeper-panel",
      component: "ChangeGoalkeeper",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        selectOnly: true,
        addGoalkeeperIdToEvent: "penalty-shot",
        sendGoalKeeperChangeEvent: true,
        saveEvent: "goalKeeperChange",
        onCourtOnly: true,
      },
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "penalty-shot", type: "from" },
            {
              action: "nextState",
              value: "penalty-shot-player",
              type: "primary",
            },
          ],
        },
      ],
    },
  ],
};
